import { GemType } from '~/components/Rock/types'

export enum MultGameModes {
  SPRINT_100 = '100 Sprint',
  SURVIVAL = 'Survival',
  TABLE_MASTER_0 = 'Table Master_0',
  TABLE_MASTER_1 = 'Table Master_1',
  TABLE_MASTER_2 = 'Table Master_2',
  TABLE_MASTER_3 = 'Table Master_3',
  TABLE_MASTER_4 = 'Table Master_4',
  TABLE_MASTER_5 = 'Table Master_5',
  TABLE_MASTER_6 = 'Table Master_6',
  TABLE_MASTER_7 = 'Table Master_7',
  TABLE_MASTER_8 = 'Table Master_8',
  TABLE_MASTER_9 = 'Table Master_9',
  TABLE_MASTER_10 = 'Table Master_10',
}

export interface MultGameRewards {
  awardPoints: number
  gemType: GemType
  gemCount: number
}

export interface TRoundData {
  gameMode: MultGameModes
  startTime: Date
  endTime: Date
  score: number
  maxStreak: number
  accuracy: number
  correctAnswers: number
  totalAnswers: number
}

export interface THighScore {
  id?: number
  gameMode: MultGameModes
  highScore: number
  hsDate: Date
  topAccuracy: number
  taDate: Date
  topStreak: number
  tsDate: Date
  achievedTier: number
  rewardGivenDate: Date
}

export interface TMultGameRound {
  roundData: TRoundData
  highScores?: THighScore
  reward?: { gemType: 'ruby'; siteScore: number }
}

export interface TWorkoutQuestion {
  id: number
  userId: number
  gameMode: MultGameModes
  time: Date
  leftFactor: number
  rightFactor: number
  answer: number
  isCorrected: boolean
}

export type TMultGameHighScores = THighScore[]

export interface TStat {
  startTime: string
  endTime: string
  score?: number
  accuracy?: number
}

export enum StatTypes {
  SCORE = 'score',
  ACCURACY = 'accuracy',
  TIME_TAKEN = 'time_taken',
}

export enum TimePeriods {
  SEVEN_DAYS = 'seven_days',
  ONE_MONTH = 'one_month',
  ONE_YEAR = 'one_year',
  ALL_TIME = 'all_time',
}

export type TStatType = StatTypes.SCORE | StatTypes.ACCURACY | StatTypes.TIME_TAKEN
type TTimePeriod = TimePeriods.SEVEN_DAYS | TimePeriods.ONE_MONTH | TimePeriods.ONE_YEAR | TimePeriods.ALL_TIME

export interface TStatFilters {
  gameMode: MultGameModes
  statType: TStatType
  timePeriod: TTimePeriod
}

export interface TPlaycanvasRequest {
  type: string
  dataType: string
  data?: any
}
